import { useEffect, useState } from "react";
import { Navigate, useParams } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  const { examId } = useParams();
  const [status, setStatus] = useState("loading"); // loading | ok | reject

  useEffect(() => {
    fetch("/api/session", { credentials: "include" })
      .then(res => res.ok ? res.json() : null)
      .then(data => {
        if (!data?.active) {
          setStatus("reject");
          return;
        }

        // 🔒 level mismatch
        if (examId && data.examId !== examId) {
          //setStatus("reject");
          //return;
        }

        setStatus("ok");
      })
      .catch(() => setStatus("reject"));
  }, [examId]);

  if (status === "loading") {
    return <div style={{ padding: 40 }}>Checking exam authorization…</div>;
  }

  if (status === "reject") {
    return <Navigate to="/login" replace />;
  }

  return children;
}
